import getI18nProps from '@/utils/i18/getI18nProps';
import Fairness from '@/components/features/casino/fairness-rush';
import CatchError from '@/components/system/CacthError';

export function CasinoFairness() {
  return <Fairness />;
}

// export const runtime = 'experimental-edge';
export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
}

export default CatchError(CasinoFairness);
